import Vector from "@/types/Vector"
import clsx from "clsx"
import { createElement } from "react"
import styles from "./topline.module.scss"

interface Props {
    icon?: Vector
    iconSize?: number
    label: string
    containerClassName?: string
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div'
}

export default function Topline({ icon, iconSize, label, containerClassName, tag = 'h4' }: Props) {
    const Icon = icon

    return <div className={clsx(styles.container, containerClassName)}>
        {Icon != undefined ? <Icon className={styles.icon} style={iconSize != undefined ? { width: `${iconSize}px !important` } : undefined} /> : undefined}
        {createElement(tag, { className: styles.label, dangerouslySetInnerHTML: { __html: label } })}
    </div>
}